import React, { useState } from "react";

import { UploadOutlined } from "@ant-design/icons";
import { Button } from "antd";

import InviteModal from "./Common/Invite/InviteModal";

import {
  canUploadSampleSubmissionExcel,
  hasPermission,
  permissions,
} from "../../../utils/Permissions";

import { ReactComponent as AddCircleIcon } from "../../../assets/images/subscriptions/add-circle-fill.svg";
import { ReactComponent as GroupIcon } from "../../../assets/images/subscriptions/group-line.svg";
import { ReactComponent as MicroscopeIllustration } from "../../../assets/images/subscriptions/Microscope.svg";

import "./SampleSubmissionLandingState.css";

export default function SampleSubmissionLandingState({
  onCreateSubmission,
  onUploadExcel,
}) {
  const [showInvite, setShowInvite] = useState(false);
  const canShare = hasPermission(permissions.sampleSubmission.share);
  const canUploadExcel = canUploadSampleSubmissionExcel();

  return (
    <>
      <section className="SampleSubmissionLandingState">
        <div className="SampleSubmissionLandingState__Content">
          <h1 className="SampleSubmissionLandingState__Heading">Sample Submission</h1>
          <p className="SampleSubmissionLandingState__Text">
            Start by submitting your sample forms and analysis requests.
          </p>

          <div className="SampleSubmissionLandingState__Actions">
            <Button
              type="primary"
              className="SampleSubmissionLandingState__CreateButton"
              onClick={onCreateSubmission}
              icon={<AddCircleIcon aria-hidden />}
            >
              Create New Sample Submission
            </Button>

            {canShare && (
              <Button
                type="default"
                className="SampleSubmissionLandingState__ShareButton"
                onClick={() => setShowInvite(true)}
                icon={<GroupIcon aria-hidden />}
              >
                Share Sample Submission
              </Button>
            )}

            {canUploadExcel && (
              <Button
                type="default"
                className="SampleSubmissionLandingState__UploadExcelButton"
                onClick={onUploadExcel}
                icon={<UploadOutlined aria-hidden />}
              >
                Upload Excel
              </Button>
            )}
          </div>
        </div>

        <div className="SampleSubmissionLandingState__Illustration" aria-hidden>
          <MicroscopeIllustration />
        </div>
      </section>

      {showInvite && <InviteModal handleShowInvite={setShowInvite} />}
    </>
  );
}
